<template>
    <div class="getting-started wrapper">
        <h1>{{content.title}}</h1>
        <div class="lg" v-html="content.body"></div>

        <div class="investigation-group row">
            <div v-for="(inv, i) in content.investigation" :key="i" class="investigation-item col c12">
                <router-link :to="investigationPath( i )">
                    <i class="bi" :class="inv.icon"></i>
                    <div class="placeholder"></div>
                    {{ inv.title }}
                </router-link>
            </div>
        </div>

        <div class="sticky-footer">
            <button class="btn center" @click="animateOut">Next</button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { gsap } from '/src/assets/js/gsap';
    import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin';

    export default {
        name: 'GettingStarted',
        computed: {
            ...mapGetters([
                'getGettingStarted',
            ]),
            content(){
                return this.getGettingStarted
            }
        },
        methods: {
            animateOut() {
                gsap.to('h1, h3, img, p, li, .investigation-group, button', {autoAlpha: 0, stagger: { amount: 0.35}, ease: "sine.in"});
                gsap.delayedCall(1, this.next);
            },
            next() {
                this.$router.push({ path: "/sim" });
            },
            investigationPath( i ){
                const p = this.$router.currentRoute.path
                const s = this.content.investigation[ i ].slug
                return p + "/investigate/" + s
            },
        },
        mounted() {
            gsap.registerPlugin( ScrollToPlugin )
            this.$parent.appHeight()
            const tl = new gsap.timeline();
            tl.to( window, { duration : 0.5, scrollTo : 0, delay : .2, ease : "sine.out" });
            tl.from('h1, h3, img, p, li, .investigation-group, button', {autoAlpha: 0, x: "-200px", stagger: { amount: 0.5}, ease: "sine.out"}, "+=0.25");
        }
    }
</script>


